<div class="h-full w-full flex flex-col overflow-y-auto scrollbar-transparent">
    <div class="space-y-8">
        <div>
            <h2 class="text-base/7 font-semibold text-primary">Basic Information</h2>
            <p class="text-sm/6 text-secondary">Let's start with the essentials of your Brief.</p>

            <div class="mt-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 px-2">
                <div class="sm:col-span-3">
                    <label for="first-name" class="block text-sm/6 font-medium text-primary">Brief title</label>
                    <div class="mt-2">
                        <input [formField]="createBriefService.basicInfoForm.briefTitle" id="brief-title" type="text"
                            class="input-primary text-primary" />
                        @if (createBriefService.basicInfoForm.briefTitle().touched() &&
                        createBriefService.basicInfoForm.briefTitle().invalid()) {
                        <ul class="error-list">
                            @for (error of createBriefService.basicInfoForm.briefTitle().errors(); track error) {
                            <li class="text-error-light flex items-start gap-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                    stroke-linejoin="round" class="shrink-0 mt-0.5" aria-hidden="true">
                                    <path
                                        d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                    <path d="M12 9v4" />
                                    <path d="M12 17h.01" />
                                </svg>
                                {{ error.message }}
                            </li>
                            }
                        </ul>
                        }
                    </div>
                </div>

                <div class="sm:col-span-3">
                    <label for="first-name" class="block text-sm/6 font-medium text-primary">Campaign</label>
                    @if (allCampaigns()) {
                    <el-select id="select" name="selected" [value]="campaignSelectValue()" class="mt-2 block">
                        <button type="button" class="grid w-full grid-cols-1 text-primary dropdown-select-primary-btn">
                            <el-selectedcontent class="col-start-1 row-start-1 flex items-center gap-3 pr-6">
                                @if (createBriefService.selectedCampaign()) {
                                <img [src]="createBriefService.selectedCampaign()?.campaignPhoto ? imageService.getImageSource(createBriefService.selectedCampaign()?.campaignPhoto, 'gallery') : 'https://ionicframework.com/docs/img/demos/avatar.svg'"
                                    alt=""
                                    class="size-5 shrink-0 rounded-full dark:bg-gray-700 bg-gray-300 outline -outline-offset-1 outline-white/10" />
                                <span class="block truncate">{{ createBriefService.selectedCampaign()?.campaignName
                                    }}</span>
                                } @else {
                                <div
                                    class="size-5 shrink-0 rounded-full outline -outline-offset-1 outline-white/10 flex items-center justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-5">
                                        <path
                                            d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z" />
                                        <path d="m9.5 10.5 5 5" />
                                        <path d="m14.5 10.5-5 5" />
                                    </svg>
                                </div>
                                <span class="block truncate">No Campaign</span>
                                }
                            </el-selectedcontent>
                            <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true"
                                class="col-start-1 row-start-1 size-5 self-center justify-self-end text-secondary sm:size-4">
                                <path
                                    d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                        </button>

                        <el-options anchor="bottom start" popover class="dropdown-select-primary-menu">
                            <button type="button"
                                class="group relative block w-full cursor-pointer border-b border-zinc-200 py-2 pr-3 pl-3 text-left text-primary select-none hover:bg-primary/10 focus:bg-primary focus:text-primary-foreground focus:outline-hidden dark:border-white/10"
                                (click)="onAddCampaignClick($event)">
                                <div class="flex items-center">
                                    <div
                                        class="flex size-5 shrink-0 items-center justify-center rounded-full bg-primary/15 text-accent/90">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-4"
                                            aria-hidden="true">
                                            <path d="M5 12h14" />
                                            <path d="M12 5v14" />
                                        </svg>
                                    </div>
                                    <span class="ml-3 block truncate font-medium">Add Campaign</span>
                                </div>
                            </button>
                            <el-option [value]="campaignSelectNoneValue"
                                (click)="createBriefService.selectedCampaign.set(undefined)"
                                class="group/option relative block cursor-default py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary focus:outline-hidden">
                                <div class="flex items-center">
                                    <div class="size-5 shrink-0 rounded-full">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path
                                                d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z" />
                                            <path d="m9.5 10.5 5 5" />
                                            <path d="m14.5 10.5-5 5" />
                                        </svg>
                                    </div>
                                    <span
                                        class="ml-3 block truncate font-normal group-aria-selected/option:font-semibold">No
                                        Campaign</span>
                                </div>
                                <span
                                    class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-not-aria-selected/option:hidden group-focus/option:text-primary in-[el-selectedcontent]:hidden">
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                        class="size-5">
                                        <path
                                            d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                            clip-rule="evenodd" fill-rule="evenodd" />
                                    </svg>
                                </span>
                            </el-option>
                            @for (campaign of allCampaigns(); track campaign.id) {
                            <el-option [value]="campaign.id" (click)="createBriefService.selectedCampaign.set(campaign)"
                                class="group/option relative block cursor-default py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary focus:outline-hidden">
                                <div class="flex items-center">
                                    <img class="size-5 shrink-0 rounded-full"
                                        [src]="campaign.campaignPhoto ? imageService.getImageSource(campaign.campaignPhoto, 'gallery') : 'https://ionicframework.com/docs/img/demos/avatar.svg'"
                                        alt />
                                    <span
                                        class="ml-3 block truncate font-normal group-aria-selected/option:font-semibold">
                                        {{ campaign.campaignName }}</span>
                                </div>
                                <span
                                    class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-not-aria-selected/option:hidden group-focus/option:text-primary in-[el-selectedcontent]:hidden">
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                        class="size-5">
                                        <path
                                            d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                            clip-rule="evenodd" fill-rule="evenodd" />
                                    </svg>
                                </span>
                            </el-option>
                            }
                        </el-options>
                    </el-select>
                    }
                </div>
            </div>
        </div>


        <div>
            <div class="flex flex-row items-center justify-between">
                <div>
                    <label for="select" class="block text-sm/6 font-medium text-primary">Product to be
                        advertised</label>
                    <p class="text-sm/6 text-secondary">Select the product you want to advertise.</p>
                </div>
                <div class="flex flex-row items-center gap-x-2">

                    <div class="grid grid-cols-1">
                        <input [formField]="productSearchQueryForm.query" id="product-search" type="text"
                            placeholder="Product Search" class="input-icon text-primary" />
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-500 sm:size-4">
                            <path d="m21 21-4.34-4.34" />
                            <circle cx="11" cy="11" r="8" />
                        </svg>
                    </div>

                    <button (click)="showCreateProductModal.set(true)" type="button" [appTooltip]="'Add Product'" position="left" class="btn-fab-primary">
                        <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5">
                            <path
                                d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                        </svg>
                    </button>
                </div>
            </div>

            @if (allProducts()) {
            <ul role="list" class="mt-2 grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-4 sm:gap-x-6 lg:grid-cols-6 px-2">
                @for (product of displayProducts(); track product.id) {
                <li class="relative">
                    <div (click)="onProductSelect(product)"
                        class="aspect-10/7 flex items-center justify-center group overflow-hidden rounded-lg bg-gray-800 focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary cursor-pointer"
                        [class]="createBriefService.selectedProduct()?.id === product.id ? 'outline-2 outline-offset-2 outline-primary' : ''">
                        @if (createBriefService.selectedProduct()?.id === product.id) {
                        <div class="absolute right-2 top-2 text-green-500">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                class="size-6">
                                <path fill-rule="evenodd"
                                    d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                    clip-rule="evenodd" />
                            </svg>

                        </div>
                        }
                        <img [src]="imageService.getImageSource(product.productImage, 'gallery_xl')" alt=""
                            class="pointer-events-none aspect-10/7 rounded-lg object-cover outline -outline-offset-1 outline-white/10 group-hover:opacity-75" />
                        <button type="button" class="absolute inset-0 focus:outline-hidden">
                            <span class="sr-only">View details for IMG_4985.HEIC</span>
                        </button>
                    </div>
                    <p class="pointer-events-none mt-2 block truncate text-xs font-medium text-primary">{{
                        product.productName }}</p>
                </li>
                }
            </ul>
            }
        </div>

        @if (createBriefService.selectedProduct() && createBriefService.selectedProduct()?.productType === 0) {
        <div class="sm:col-span-full">
            <label for="select" class="block text-sm/6 font-medium text-primary">Deliveries
                <p class="text-xs text-secondary">Would you like to send the product to the creator?</p>
            </label>
            <ul role="list" class="mt-1 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3">
                @for (delivery of deliveryOptions; track delivery.id) {
                <li class="col-span-1 flex rounded-md" (click)="createBriefService.deliveryType.set(delivery.id)"
                    [class]="createBriefService.deliveryType() === delivery.id ? 'border-primary' : 'border-zinc-500'">
                    <div class="flex w-16 shrink-0 items-center justify-center rounded-l-md text-sm font-medium"
                        [class]="delivery.colour">
                        @switch (delivery.id) {
                        @case (DeliveryTypeEnum.none) {
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="size-5 sm:size-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                        </svg>
                        }
                        @case (DeliveryTypeEnum.Discount_Code) {
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="size-5 sm:size-6">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5ZM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5ZM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z" />
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M6.75 6.75h.75v.75h-.75v-.75ZM6.75 16.5h.75v.75h-.75v-.75ZM16.5 6.75h.75v.75h-.75v-.75ZM13.5 13.5h.75v.75h-.75v-.75ZM13.5 19.5h.75v.75h-.75v-.75ZM19.5 13.5h.75v.75h-.75v-.75ZM19.5 19.5h.75v.75h-.75v-.75ZM16.5 16.5h.75v.75h-.75v-.75Z" />
                        </svg>
                        }
                        @case (DeliveryTypeEnum.Address_Required) {
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="size-5 sm:size-6">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M21 11.25v8.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 1 0 9.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1 1 14.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z" />
                        </svg>
                        }
                        }
                    </div>
                    <div
                        class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-zinc-300 dark:border-white/10">
                        <div class="flex-1 truncate px-4 py-2 text-sm">
                            <a class="font-medium text-primary hover:text-gray-200">{{ delivery.title }}</a>
                            <p class="text-secondary truncate">{{ delivery.desc }}</p>
                        </div>
                        <div class="shrink-0 pr-2 flex items-center justify-center text-primary">
                            @if (createBriefService.deliveryType() === delivery.id) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-6">
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            }
                        </div>
                    </div>
                </li>
                }
            </ul>
        </div>
        }

        <div>
            <h2 class="text-base/7 font-semibold text-primary">Brief Goals</h2>
            <p class="text-sm/6 text-secondary">What do you want to achieve with this brief?</p>

            <div class="flex flex-col gap-y-4">
                <div>
                    <label for="comment" class="block text-sm/6 font-medium text-primary">
                        Awareness
                    </label>
                    <ul role="list" class="mt-1 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3">
                        @for (goal of awarenessGoals; track goal.id) {
                        <li class="col-span-1 flex rounded-md" (click)="createBriefService.selectedBriefGoal.set(goal)"
                            [class]="createBriefService.selectedBriefGoal()?.id === goal.id ? 'border-primary' : 'border-zinc-500'">
                            <div class="flex w-16 shrink-0 items-center justify-center rounded-l-md text-sm font-medium"
                                [class]="goal.color">
                                <span [innerHTML]="getSafeHtml(goal.icon)"></span>
                            </div>
                            <div
                                class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-zinc-300 dark:border-white/10">
                                <div class="flex-1 truncate px-4 py-2 text-sm">
                                    <a class="font-medium text-primary hover:text-gray-200">{{ goal.name }}</a>
                                    <p class="text-secondary truncate">{{ goal.description }}</p>
                                </div>
                                <div class="shrink-0 pr-2 flex items-center justify-center text-primary">
                                    @if (createBriefService.selectedBriefGoal()?.id === goal.id) {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-6">
                                        <circle cx="12" cy="12" r="10" />
                                        <path d="m9 12 2 2 4-4" />
                                    </svg>
                                    }
                                </div>
                            </div>
                        </li>
                        }

                    </ul>
                </div>

                <div>
                    <label for="comment" class="block text-sm/6 font-medium text-primary">
                        Consideration
                    </label>
                    <ul role="list" class="mt-1 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3">
                        @for (goal of considerationGoals; track goal.id) {
                        <li class="col-span-1 flex rounded-md" (click)="createBriefService.selectedBriefGoal.set(goal)"
                            [class]="createBriefService.selectedBriefGoal()?.id === goal.id ? 'border-primary' : 'border-zinc-500'">
                            <div class="flex w-16 shrink-0 items-center justify-center rounded-l-md text-sm font-medium"
                                [class]="goal.color">
                                <span [innerHTML]="getSafeHtml(goal.icon)"></span>
                            </div>
                            <div
                                class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-zinc-300 dark:border-white/10">
                                <div class="flex-1 truncate px-4 py-2 text-sm">
                                    <a class="font-medium text-primary hover:text-gray-200">{{ goal.name }}</a>
                                    <p class="text-secondary truncate">{{ goal.description }}</p>
                                </div>
                                <div class="shrink-0 pr-2 flex items-center justify-center text-primary">
                                    @if (createBriefService.selectedBriefGoal()?.id === goal.id) {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-6">
                                        <circle cx="12" cy="12" r="10" />
                                        <path d="m9 12 2 2 4-4" />
                                    </svg>
                                    }
                                </div>
                            </div>
                        </li>
                        }

                    </ul>
                </div>

                <div>
                    <label for="comment" class="block text-sm/6 font-medium text-primary">
                        Conversion
                    </label>
                    <ul role="list" class="mt-1 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3">
                        @for (goal of conversionGoals; track goal.id) {
                        <li class="col-span-1 flex rounded-md" (click)="createBriefService.selectedBriefGoal.set(goal)"
                            [class]="createBriefService.selectedBriefGoal()?.id === goal.id ? 'border-primary' : 'border-zinc-500'">
                            <div class="flex w-16 shrink-0 items-center justify-center rounded-l-md text-sm font-medium"
                                [class]="goal.color">
                                <span [innerHTML]="getSafeHtml(goal.icon)"></span>
                            </div>
                            <div
                                class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-zinc-300 dark:border-white/10">
                                <div class="flex-1 truncate px-4 py-2 text-sm">
                                    <a class="font-medium text-primary hover:text-gray-200">{{ goal.name }}</a>
                                    <p class="text-secondary truncate">{{ goal.description }}</p>
                                </div>
                                <div class="shrink-0 pr-2 flex items-center justify-center text-primary">
                                    @if (createBriefService.selectedBriefGoal()?.id === goal.id) {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-6">
                                        <circle cx="12" cy="12" r="10" />
                                        <path d="m9 12 2 2 4-4" />
                                    </svg>
                                    }
                                </div>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

@if (showCreateProductModal()) {
<mb-brand-products-create (close)="showCreateProductModal.set(false)"
    (productAdded)="onProductAdded($event)"></mb-brand-products-create>
}

@if (showCreateCampaignModal()) {
<create-campaign class="h-full w-full" (campaignCreated)="onCampaignCreated($event)"
    (close)="showCreateCampaignModal.set(false)"></create-campaign>
}